import React from "react";

import { isEmpty } from "lodash/fp";

import useProductivityIntegrationStatus from "@app/analytics/hooks/integrations/useProductivityIntegrationStatus";
import useForYouTeaser from "@app/analytics/MeetingReports/hooks/useForYouTeaser";
import useResponsiveView from "@app/common/hooks/useResponsiveView";
import Config from "@app/config";

import Stack, { Row } from "@rui/Stack";

import ForYouTeaser from "./ForYouTeaser";
import ReadoutStatus from "./ReadoutStatus/ReadoutStatus";

const ReportStatusesAndUpsells = () => {
  const integrationStatus = useProductivityIntegrationStatus();
  const forYouTeaser = useForYouTeaser();
  const { inMobileView } = useResponsiveView();

  const fypTeaserVisible =
    forYouTeaser.shouldUpsell || Boolean(forYouTeaser.result);

  if (!fypTeaserVisible && isEmpty(integrationStatus.statuses)) return null;

  // Wrap the upsells in mobile view due to the overflow: hidden shrinking them while in columns
  // Ideally the solution is to just use overflow: clip but that doesn't work properly in safari and iOS
  const UpsellWrapper = inMobileView ? Row : React.Fragment;

  return (
    <Stack
      direction={{ xxs: "column", mobile: "row" }}
      spacing={{ xxs: 1, mobile: 2 }}
      justifyContent="space-evenly"
      pt={2}
    >
      {Config.flags.enableInitialReadoutExperience && (
        <UpsellWrapper>
          <ReadoutStatus
            additionalModules={fypTeaserVisible ? 1 : 0}
            {...integrationStatus}
          />
        </UpsellWrapper>
      )}
      <UpsellWrapper>
        <ForYouTeaser {...forYouTeaser} />
      </UpsellWrapper>
    </Stack>
  );
};

export default ReportStatusesAndUpsells;
